<template>
  <div class="col-md-12 card" @click="maybeWarnSetProject()">
    <div class="row" style="margin-top: 15px;">
      <div class="col-md-4"><label><Strong><h5>Purchase Order Job Data</h5></Strong></label></div>
      <div class="col-md-8"><label><Strong><h5>PTRAC Job Fields</h5></Strong></label></div>
    </div>

    <div class="row">
      <div class="col-md-4 sp-align-fields">
        <div v-if="poJobData.taskName">
          <strong class="labels">Task Name:</strong> {{ poJobData.taskName }}
        </div>
      </div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Department</strong>
        <p-checkbox class="inline-block" :disabled="!canSelectInspection || !projectSet" style="margin-right: 30px;" v-model="isInspection" name="inspection">Inspection</p-checkbox>
        <p-checkbox class="inline-block" :disabled="!canSelectSurvey || !projectSet" v-model="isSurvey" name="survey">Survey</p-checkbox>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4 sp-align-fields">
        <div v-if="poJobData.description">
          <strong class="labels">Task Description: </strong> {{ poJobData.description }}
        </div>
      </div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Job Template</strong>
        <v-select
            class="inline-block"
            id="jobTemplate"
            v-model="jobTemplate"
            v-validate="modelValidations.jobTemplate"
            name="jobTemplate"
            placeholder="Select a Job Template"
            style="min-width: 300px;"
            @input="setJobTemplate"
            :disabled="!ptracJob.departmentId || !projectSet"
            :options="jobTemplatesForSelect">
        </v-select>
        <small class="text-danger" style="display: block" v-show="errors.has('jobTemplate')">
          {{ getError('jobTemplate') }}
        </small>
      </div>
    </div>

    <div class="row" v-if="ptracJob.jobTemplateId">
      <div class="line"></div>
      <div class="col-md-4"></div>
      <div class="col-md-8">
        <div class="inline-block">
          <strong class="labels">Job Name:</strong>
        </div>
        <div class="job-name-container grey-font inline-block m-left-10">
          <h6>{{ ptracJob.name }}</h6>
        </div>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4 sp-align-fields">
        <div v-if="poJobData.jobNum" style="width: 100%">
          <strong class="labels">Job Number: </strong> {{ poJobData.jobNum }}
          <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.JOB_FIELDS.JOB_NUM)">
            <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.JOB_FIELDS.JOB_NUM)"/>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <label style="display: block">
          <strong class="labels">Job Number</strong>
          <el-tooltip class="m-left-10" style="margin-top: 0px;" effect="dark" content="Click the ' + ' button to auto-generate a job number with the pattern (yyyy-mm--xxx). Alternatively, you can enter any value you choose. The job number will be appended to the customer name when generating an invoice in QuickBooks. This will associate the invoice with the specified QuickBooks job." placement="top">
            <img class="icon-help" src="static/img/icon-help.png"/>
          </el-tooltip>
        </label>
        <el-input
            name="jobNumber"
            clearable
            :disabled="!canEdit || !projectSet"
            style="max-width: 204px; margin-right: 10px;"
            class="job-number"
            v-model="ptracJob.number"
            @blur="ifJobNumberExistsThenWarn"
            placeholder="Job Number">
        </el-input>
        <button @click="generateJobNumber" :disabled="!projectSet" class="btn btn-fill btn-info btn-sm btn-save tiny-label-button inline-block" style="margin: 0px;"> + </button>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4 sp-align-fields">
        <div v-if="poJobData.permitNumber" style="width: 100%">
          <strong class="labels">Permit Number: </strong> {{ poJobData.permitNumber }}
          <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.JOB_FIELDS.PERMIT_NUMBER)">
            <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.JOB_FIELDS.PERMIT_NUMBER)"/>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <label style="display: block">
          <strong class="labels">Permit Number</strong>
        </label>
        <el-input
            name="permitNumber"
            clearable
            :disabled="!canEdit || !projectSet"
            style="max-width: 204px;"
            v-model="ptracJob.permitNumber"
            placeholder="Permit Number">
        </el-input>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Job Coordinator</strong>
        <el-autocomplete
            style="max-width: 204px"
            data-vv-as="job coordinator"
            name="coordinatorId"
            class="inline-input"
            clearable
            :disabled="!canEdit || !projectSet"
            v-validate="modelValidations.coordinatorId"
            v-model="selectedCoordinator"
            :fetch-suggestions="findCoordinators"
            :trigger-on-focus="false"
            value-key="name"
            placeholder="Job Coordinator"
            @blur="verifyCoordinatorAutocompleteSelected"
            @select="setCoordinator">
        </el-autocomplete>
        <small class="text-danger" style="display: block" v-show="errors.has('coordinatorId')">
          {{ getError('coordinatorId') }}
        </small>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Job Priority</strong>
        <el-select class="select"
                   name="priority"
                   size="large"
                   clearable
                   :disabled="!canEdit || !projectSet"
                   placeholder="Job Priority"
                   v-validate="modelValidations.priority"
                   v-model="ptracJob.priority">
          <el-option v-for="option in priorities"
                     class="select"
                     :value="option.value"
                     :label="option.label"
                     :key="option.label">
          </el-option>
        </el-select>
        <small class="text-danger" style="display: block" v-show="errors.has('priority')">
          {{ getError('priority') }}
        </small>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Job Status</strong>
        <el-select class="select"
                   name="status"
                   size="large"
                   clearable
                   :disabled="!canEdit || !projectSet"
                   placeholder="Job Status"
                   v-validate="modelValidations.status"
                   v-model="ptracJob.status">
          <el-option v-for="option in statuses"
                     class="select"
                     :value="option.value"
                     :label="option.label"
                     :key="option.label">
          </el-option>
        </el-select>
        <small class="text-danger" style="display: block" v-show="errors.has('status')">
          {{ getError('status') }}
        </small>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4 sp-align-fields">
        <div v-if="poJobData.elevation" style="width: 100%">
          <strong class="labels">Elevation: </strong> {{ poJobData.elevation }}
          <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.JOB_FIELDS.ELEVATION)">
            <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.JOB_FIELDS.ELEVATION)"/>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Elevation</strong>
        <el-input type="input"
                  style="max-width: 204px"
                  name="elevation"
                  placeholder="Elevation"
                  :disabled="!projectSet"
                  v-model="ptracJob.elevation"
                  clearable/>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4 sp-align-fields">
        <div v-if="poJobData.builderName" style="width: 100%">
          <strong class="labels">Builder Name: </strong> {{ poJobData.builderName }}
          <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.JOB_FIELDS.BUILDER_NAME)">
            <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.JOB_FIELDS.BUILDER_NAME)"/>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Billable Client</strong>
        <el-autocomplete
            ref="clientId"
            style="max-width: 204px"
            name="clientId"
            class="inline-input"
            :debounce="150"
            clearable
            :disabled="!canEdit || !projectSet"
            v-model="selectedClient.name"
            :fetch-suggestions="findClients"
            :trigger-on-focus="false"
            value-key="name"
            placeholder="Billable Client"
            @blur="verifyClientAutocompleteSelected"
            @select="setClient">
        </el-autocomplete>
        <button v-if="isClientResult && canEdit" :disabled="!projectSet" @click="copyClientToBuilder" class="btn btn-fill btn-info btn-sm btn-save tiny-label-button inline-block m-left-5"> > </button>
        <div class="inline-block" v-if="travelCharge.value !== null">
          <el-tooltip effect="dark" placement="top" style="padding: 1px 5px; margin-top: -1px; float: right;">
            <div slot="content">
              <h6 style="text-align: center">Travel Charge</h6>
              <p style="text-align: center">{{currentFormatter.format(travelCharge.value)}}</p>
              <span v-if=isMultiplePricerules>Multiple price rules matched, actual travel charge may be zero.</span>
            </div>
            <i class="nc-icon nc-money-coins"></i>`
          </el-tooltip>
        </div>
        <small class="text-danger" style="display: block" v-show="showInvalidAutocompleteWarning('clientId')">
          {{ fieldNotValidError('Client') }}
        </small>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4 sp-align-fields">
        <div v-if="poJobData.primaryFirstName || poJobData.primaryLastName" style="width: 100%">
          <strong class="labels">Primary Name: </strong> {{ poJobData.primaryFirstName }} {{ poJobData.primaryLastName }}
          <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.JOB_FIELDS.PRIMARY_NAME)">
            <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.JOB_FIELDS.PRIMARY_NAME)"/>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Client Contact</strong>
        <el-select class="select"
                   name="clientContactId"
                   size="large"
                   clearable
                   :disabled="!canEdit || !projectSet"
                   @input="checkClientAndContactEmail"
                   placeholder="Client Contact"
                   v-model="ptracJob.clientContactId">
          <el-option v-for="option in clientContacts"
                     class="select"
                     :value="option.value"
                     :label="option.label"
                     :key="option.label">
          </el-option>
        </el-select>
        <button v-if="isClientResult && canEdit" @click="addClientContact" :disabled="!projectSet" class="btn btn-fill btn-info btn-sm btn-save tiny-label-button m-left-5"> + </button>
        <button v-if="isClientResult && ptracJob.clientContactId && canEdit" @click="editClientContact" :disabled="!projectSet" class="btn btn-fill btn-info btn-sm btn-save tiny-label-button m-left-5"> edit </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4" v-if="poJobData.primaryPhoneNumber">
        <li class="contact-info"><strong class="labels">Primary Phone Number: </strong> {{ poJobData.primaryPhoneNumber }} </li>
      </div>
      <div class="col-md-8">
        <div v-if="primaryContactInfo.workPhone && poJobData.primaryPhoneNumber">
          <li class="contact-info"><strong class="labels">Work Phone: </strong> {{ primaryContactInfo.workPhone }} </li>
        </div>
        <div v-if="primaryContactInfo.mobilePhone && poJobData.primaryPhoneNumber">
          <li class="contact-info"><strong class="labels">Mobile Phone: </strong> {{ primaryContactInfo.mobilePhone }} </li>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4" v-if="poJobData.primaryEmailAddress">
        <li class="contact-info"><strong class="labels">Primary Email: </strong> {{ poJobData.primaryEmailAddress }} </li>
      </div>
      <div class="col-md-8" v-if="poJobData.primaryEmailAddress && primaryContactInfo.email">
        <li class="contact-info"><strong class="labels">Contact Email: </strong> {{ primaryContactInfo.email }} </li>
      </div>
    </div>

    <div class="line"></div>

    <div class="row" >
      <div class="col-md-4"></div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Builder</strong>
        <el-autocomplete
            ref="builderId"
            style="max-width: 204px"
            name="builderId"
            class="inline-input"
            :debounce="150"
            clearable
            :disabled="!canEdit || !projectSet"
            v-model="selectedBuilder.name"
            :fetch-suggestions="findBuilders"
            :trigger-on-focus="false"
            value-key="name"
            placeholder="Builder"
            @blur="verifyBuilderAutocompleteSelected"
            @select="setBuilder">
        </el-autocomplete>
        <small class="text-danger" style="display: block" v-show="showInvalidAutocompleteWarning('builderId')">
          {{ fieldNotValidError('Builder') }}
        </small>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Builder Contact</strong>
        <el-select class="select"
                   name="builderContactId"
                   size="large"
                   clearable
                   :disabled="!canEdit || !projectSet"
                   @input="checkBuilderAndContactEmail"
                   placeholder="Builder Contact"
                   v-model="ptracJob.builderContactId">
          <el-option v-for="option in builderContacts"
                     class="select"
                     :value="option.value"
                     :label="option.label"
                     :key="option.label">
          </el-option>
        </el-select>
        <button v-if="isBuilderResult && canEdit" @click="addBuilderContact" :disabled="!projectSet" class="btn btn-fill btn-info btn-sm btn-save tiny-label-button m-left-5" style="margin-bottom: 0px; margin-top: 0px;"> + </button>
        <button v-if="isBuilderResult && ptracJob.builderContactId && canEdit" @click="editBuilderContact" :disabled="!projectSet" class="btn btn-fill btn-info btn-sm btn-save tiny-label-button m-left-5" style="margin-bottom: 0px; margin-top: 0px;"> edit </button>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4 sp-align-fields">
        <div v-if="poJobData.communityId">
          <strong class="labels">Community Id: </strong> {{ poJobData.communityId }}
        </div>
      </div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Community</strong>
        <el-autocomplete
            style="max-width: 204px"
            ref="community"
            name="community"
            class="inline-input"
            clearable
            :disabled="!canEdit || !projectSet"
            v-model="selectedCommunity.name"
            :fetch-suggestions="findCommunities"
            :trigger-on-focus="false"
            value-key="name"
            placeholder="Community"
            @blur="verifyCommunityAutocompleteSelected"
            @focus="verifyClientOrBuilderSelected"
            @select="setCommunity">
        </el-autocomplete>
        <small class="text-danger" style="display: block" v-show="showInvalidAutocompleteWarning('community')">
          {{ fieldNotValidError('Community') }}
        </small>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Plan Name</strong>
        <el-autocomplete
            style="max-width: 204px"
            name="planNameId"
            ref="planNameId"
            class="inline-input"
            clearable
            :disabled="!projectSet"
            v-model="selectedPlanName"
            :fetch-suggestions="findPlanNames"
            :trigger-on-focus="false"
            value-key="plan"
            placeholder="Plan Name"
            @blur="verifyPlanNameAutocompleteSelected"
            @focus="verifyBuilderSelected"
            @select="setPlanName">
        </el-autocomplete>
        <button v-if="selectedPlanName && canEdit" @click="editPlanName" :disabled="!projectSet" class="btn btn-fill btn-info btn-sm btn-save tiny-label-button inline-block m-left-5"> edit </button>
        <button v-if="!selectedPlanName && canEdit" @click="addPlanName" :disabled="!projectSet" class="btn btn-fill btn-info btn-sm btn-save tiny-label-button inline-block m-left-5"> + </button>
        <span class="inline-block" v-if="selectedPlanName && planNamePDF">
          <el-tooltip class="item" effect="dark" placement="right" style="padding: 1px 5px; margin-top: -2px;">
            <div slot="content" style="text-align: center"> {{ planNamePDF }} </div>
            <img src="static/img/file-mgr/pdf-small.png"/>
          </el-tooltip>
        </span>
        <small class="text-danger" style="display: block" v-show="showInvalidAutocompleteWarning('planNameId')">
          {{ fieldNotValidError('Plan Name') }}
        </small>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4 sp-align-fields">
        <div v-if="poJobData.issueDate" style="width: 100%">
          <strong class="labels">Issue Date: </strong> {{ poJobData.issueDate | formatDate }}
          <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.JOB_FIELDS.ISSUE_DATE)">
            <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.JOB_FIELDS.ISSUE_DATE)"/>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Date Received</strong>
        <el-date-picker
            :disabled="!canEdit || !projectSet"
            name="dateReceived"
            data-vv-as="date received"
            style="max-width: 204px"
            :format="constants.DATE.FORMAT.DISPLAY"
            :value-format="constants.DATE.FORMAT.VALUE"
            v-validate="modelValidations.dateReceived"
            v-model="ptracJob.dateReceived"
            type="date"
            :picker-options="datePickerConfig"
            placeholder="Pick a day">
        </el-date-picker>
        <small class="text-danger" style="display: block" v-show="errors.has('dateReceived')">
          {{ getError('dateReceived') }}
        </small>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4 sp-align-fields">
        <div v-if="poJobData.startDate" style="width: 100%">
          <strong class="labels">Start Date: </strong> {{ poJobData.startDate | formatDate }}
          <div class="push-button sp-align-fields" v-if="!fieldsMatch(constants.SUPPLYPRO.JOB_FIELDS.START_DATE)">
            <img src="static/img/icon-list.png" @click="pushField(constants.SUPPLYPRO.JOB_FIELDS.START_DATE)"/>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <strong class="labels" style="display: block">Target Completion Date</strong>
        <el-date-picker
            :disabled="!canEdit || !projectSet"
            name="targetCompletionDate"
            data-vv-as="target completion date"
            :format="constants.DATE.FORMAT.DISPLAY"
            :value-format="constants.DATE.FORMAT.VALUE"
            v-validate="modelValidations.targetCompletionDate"
            v-model="ptracJob.targetCompletionDate"
            type="date"
            style="max-width: 204px"
            :picker-options="datePickerConfig"
            placeholder="Pick a day">
        </el-date-picker>
        <small class="text-danger" style="display: block" v-show="errors.has('targetCompletionDate')">
          {{ getError('targetCompletionDate') }}
        </small>
      </div>
    </div>

    <div class="line"></div>

    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-8">
        <div class="box-visual inline-block" style="max-width: 80%">
          <label><strong class="labels">Item Description</strong></label>
          <div class="pull-right" style="margin-top: -15px;">
            <button type="button" v-if="canEdit" :disabled="!projectSet" @click="editDescription" class="btn btn-fill btn-lg btn-info el-icon-edit" style="padding: 8px;"></button>
          </div>
          <div @dblclick="editDescription"><p>{{ ptracJob.description }}</p></div>
        </div>
      </div>
    </div>

    <div style="width: 100%;">
      <div class="pull-right" style="margin-top: 20px">
        <p-checkbox :disabled="!projectSet" class="inline-block" style="margin-right: 20px" v-model="createAnotherJob">Create Another Job From PO</p-checkbox>
        <button :disabled="!projectSet || isSubmitDisabled" type="button" class="inline-block btn btn-fill btn-info btn-wd" @click="validateAndSubmit">Save and Edit Tasks</button>
      </div>
    </div>
  </div>
</template>

<script>
import {sync} from 'vuex-pathify'
import {mapGetters} from 'vuex'
import Constants from '@/utilities/constants'
import vSelect from 'vue-select'
import {
  autocompleteTextButNoValue,
  autocompleteTextButNoValueMessage,
  findCommunities,
  findCompany,
  notifyError,
  notifySuccess,
  notifyWarning,
  objectBy,
  objectById,
  sleepOneSecond,
  verifyAutocompleteSelected
} from '@/utilities/utils'
import {OK} from 'http-status-codes'
import datePickerConfig from '@/components/UIComponents/DatePicker/datePickerConfig'
import {
  jobAddBuilderContact,
  jobAddClientContact,
  jobCopyClientToBuilder,
  jobEditBuilderContact,
  jobEditClientContact,
  jobFindBuilders,
  jobFindClients,
  jobFindCoordinators,
  jobFindPlanNames,
  jobAddPlanName,
  jobEditPlanName,
  jobSetPlanName,
  jobFetchPlanNamePDF,
  jobGenerateJobNumber,
  jobHydrateCompany,
  jobIfJobNumberExistsThenWarn,
  jobMaybeLoadBuilder,
  jobMaybeLoadClient,
  jobMaybeLoadCoordinator,
  jobNoCompanySelected,
  jobSetBuilder,
  jobSetClient,
  jobSetCommunity,
  jobSetCompany,
  jobSetCoordinator,
  jobVerifyBuilderSelected,
  jobVerifyClientOrBuilderSelected
} from '@/utilities/jobHelper'
import _ from 'lodash'
import {store} from '@/store/store'

const SUPPLY_PRO_CREATE = 'supplyProCreate'

export default {
  components: {
    vSelect
  },
  computed: {
    ptracJob: sync('supplyPro/job@ptracJob'),
    createAnotherJob: sync('supplyPro/job/createAnotherJob'),
    ...mapGetters({
      poJobData: 'supplyPro/job/poJobData',
      projectSet: 'supplyPro/project/projectSet',
      priorities: 'priorities/job',
      contacts: 'companies/companyContacts',
      departmentOptions: 'supplyPro/job/departmentOptions',
      jobTemplatesByDepartment: 'jobTemplates/byDepartment',
      jobTemplatesForSelect: 'jobTemplates/kvpsForSelect',
      processDefinitions: 'camunda/ptracProcessDefinitions',
      activeModals: 'modalTracker/activeModals',
      autocompleteClients: 'companies/autocompleteResultsClient',
      autocompleteBuilders: 'companies/autocompleteResultsBuilder',
      user: 'security/user'
    }),
    statuses() {
      const allStatuses = this.$store.getters['statuses/job']
      return _.filter(allStatuses, (status) => status.value !== Constants.STATUSES.CANCELLED && status.value !== Constants.STATUSES.COMPLETED)
    },
    canEdit() {
      return true
      // return this.$can('edit', Permissions.JOBS)
      // set up permissions
    },
    isMultiplePricerules() {
      return this.travelCharge.state === Constants.TRAVEL_CHARGE.STATES.UNDECIDED
    },
    isSubmitDisabled() {
      return this.isProcessing
    }
  },
  data() {
    return {
      isInspection: false,
      isSurvey: false,
      isProcessing: false,
      canSelectSurvey: false,
      canSelectInspection: false,
      jobTemplate: null,
      selectedCoordinator: null,
      selectedPlanName: null,
      planNamePDF: null,
      selectedCommunity: { id: null, name: null },
      selectedClient: { id: null, name: null },
      selectedBuilder: { id: null, name: null },
      isClientResult: false,
      isBuilderResult: false,
      isAddClientContact: false,
      isAddBuilderContact: false,
      onHoldWarning: false,
      builderContacts: [],
      clientContacts: [],
      primaryContactInfo: {},
      constants: Constants,
      datePickerConfig,
      modelValidations: {
        jobTemplate: {
          required: true
        },
        departments: {
          required: true
        },
        coordinatorId: {
          required: true
        },
        priority: {
          required: true
        },
        status: {
          required: true
        },
        dateReceived: {
          required: true
        },
        targetCompletionDate: {
          required: true
        }
      },
      travelCharge: {
        state: null,
        value: null
      },
      newCompany: {
        builder: false,
        client: false
      },
      currentFormatter : Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      })
    }
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    showInvalidAutocompleteWarning(refAndPathName) {
      // $ref has to match prop in store
      return autocompleteTextButNoValue(this, refAndPathName, this.$store.get(`supplyPro/job/ptracJob@${refAndPathName}`))
    },
    fieldNotValidError(field) {
      return autocompleteTextButNoValueMessage(field)
    },
    async pushField(field) {
      if (!this.projectSet) {
        return
      }
      const poJob = this.$store.get('supplyPro/job/poJobData')
      switch (field) {
        case Constants.SUPPLYPRO.JOB_FIELDS.JOB_NUM:
          this.$store.set('supplyPro/job/ptracJob@number', poJob.jobNum)
          break
        case Constants.SUPPLYPRO.JOB_FIELDS.PERMIT_NUMBER:
          this.$store.set('supplyPro/job/ptracJob@permitNumber', poJob.permitNumber)
          break
        case Constants.SUPPLYPRO.JOB_FIELDS.ELEVATION:
          this.$store.set('supplyPro/job/ptracJob@elevation', poJob.elevation)
          break
        case Constants.SUPPLYPRO.JOB_FIELDS.BUILDER_NAME:
          const response = await this.findCompany(poJob.builderName, Constants.COMPANY.TYPES.CLIENT)
          if (response && OK === response.status && response.data.length > 0) {
            this.setClient(response.data[0])
          }
          break
        case Constants.SUPPLYPRO.JOB_FIELDS.PRIMARY_NAME:
          if (!this.findMatchingPOContact()) {
            const payload = {
              contact: {
                name: `${this.poJobData.primaryFirstName ? this.poJobData.primaryFirstName + ' ' : ''}${this.poJobData.primaryLastName ? this.poJobData.primaryLastName : ''}`,
                firstName: this.poJobData.primaryFirstName,
                lastName: this.poJobData.primaryLastName,
                emails: [this.poJobData.primaryEmailAddress],
                workPhone: this.poJobData.primaryPhoneNumber
              },
              saveCompany: true,
              company: this.selectedClient.name
            }

            this.isAddClientContact = true
            this.isAddBuilderContact = false
            await jobHydrateCompany(this, this.$store.get('supplyPro/job/ptracJob@clientId'))
            this.$eventHub.$emit('show-modal-2', 'No Contact Found', payload, '500px')
          }
          break
        case Constants.SUPPLYPRO.JOB_FIELDS.ISSUE_DATE:
          this.$store.set('supplyPro/job/ptracJob@dateReceived', poJob.issueDate)
          break
        case Constants.SUPPLYPRO.JOB_FIELDS.START_DATE:
          this.$store.set('supplyPro/job/ptracJob@targetCompletionDate', poJob.startDate)
      }
    },
    fieldsMatch(field) {
      const poJob = this.$store.get('supplyPro/job/poJobData')
      const ptracJob = this.$store.get('supplyPro/job/ptracJob')
      if (field === Constants.SUPPLYPRO.JOB_FIELDS.JOB_NUM && poJob.jobNum) {
        return poJob.jobNum === ptracJob.number || (!poJob.jobNum && !ptracJob.number)
      }
      if (field === Constants.SUPPLYPRO.JOB_FIELDS.PERMIT_NUMBER && poJob.permitNumber) {
        return poJob.permitNumber === ptracJob.permitNumber || (!poJob.permitNumber && !ptracJob.permitNumber)
      }
      if (field === Constants.SUPPLYPRO.JOB_FIELDS.ELEVATION && poJob.elevation) {
        return poJob.elevation === ptracJob.elevation || (!poJob.elevation && !ptracJob.elevation)
      }
      if (field === Constants.SUPPLYPRO.JOB_FIELDS.BUILDER_NAME && poJob.builderName && this.selectedClient.name) {
        return poJob.builderName.toLowerCase().trim() === this.selectedClient.name.toLowerCase().trim()
      }
      if (field === Constants.SUPPLYPRO.JOB_FIELDS.PRIMARY_NAME && (poJob.primaryFirstName || poJob.primaryLastName)) {
        const ptracContactName = this.clientContacts.find(({ value }) => value === ptracJob.clientContactId)
        if (ptracContactName) {
          return `${poJob.primaryFirstName} ${poJob.primaryLastName}` === ptracContactName.label
        }
        return !poJob.primaryFirstName && !poJob.primaryLastName
      }
      if (field === Constants.SUPPLYPRO.JOB_FIELDS.ISSUE_DATE && poJob.issueDate) {
        return poJob.issueDate === ptracJob.dateReceived
      }
      if (field === Constants.SUPPLYPRO.JOB_FIELDS.START_DATE && poJob.startDate) {
        return poJob.startDate === ptracJob.targetCompletionDate
      }
    },
    maybeWarnSetProject() {
      if (!this.projectSet) {
        notifyWarning(this, 'Confirm Project before editing Job.')
      }
    },
    async setJobTemplate(selectedJobTemplate) {
      if (!selectedJobTemplate) {
        this.$store.commit('supplyPro/job/resetTemplate')
        return
      }
      const jobTemplate = objectById(this.jobTemplatesByDepartment, selectedJobTemplate.value)
      if (!jobTemplate) {
        console.error('Unable to load Job Template by ID', selectedJobTemplate.value)
        return
      }
      if (jobTemplate.clientId) {
        this.$store.set('supplyPro/job/ptracJob@clientId', jobTemplate.clientId)
        await this.maybeLoadClient()
        if (jobTemplate.clientContactId) {
          this.$store.set('supplyPro/job/ptracJob@clientContactId', jobTemplate.clientContactId)
          this.checkClientAndContactEmail(jobTemplate.clientContactId)
        }
      }
      if (jobTemplate.builderId) {
        this.$store.set('supplyPro/job/ptracJob@builderId', jobTemplate.builderId)
        await this.maybeLoadBuilder()
        if (jobTemplate.builderContactId) {
          this.$store.set('supplyPro/job/ptracJob@builderContactId', jobTemplate.builderContactId)
        }
      }
      if (jobTemplate.communityId) {
        const response = await this.$store.dispatch('fetchById', {
          endpoint: Constants.ENTITY_ENDPOINTS.COMMUNITIES,
          id: jobTemplate.communityId
        })
        if (OK === response.status) {
          this.selectedCommunity.id = response.data.id
          this.selectedCommunity.name = response.data.name
          this.$store.set('supplyPro/job/ptracJob@community', {
            id: response.data.id,
            name: response.data.name
          })
        }
      }
      this.$store.set('supplyPro/job/ptracJob@jobTemplateId', jobTemplate.id)
      this.$store.set('supplyPro/job/ptracJob@priority', jobTemplate.priority)
      const processDefinition = objectBy(this.processDefinitions, 'key', jobTemplate.processDefinitionKey)
      if (!processDefinition) {
        notifyError(this, 'Unable to locate Process Definition by key: ' + jobTemplate.processDefinitionKey)
        return
      }
      this.$store.set('supplyPro/job/ptracJob@processDefinitionId', processDefinition.id)
      this.$store.set('supplyPro/job/ptracJob@processDefinitionKey', processDefinition.key)
      this.$store.set('supplyPro/job/ptracJob@name', processDefinition.name)
      await this.maybeFetchTravelCharge()

      const projectId = this.$store.get('supplyPro/job/ptracJob@projectId')
      const departmentId = this.$store.get('supplyPro/job/ptracJob@departmentId')
      const response = await this.$store.dispatch('tasks/fetchReInspectionTask', {
        departmentId,
        projectId,
        jobName: encodeURIComponent(processDefinition.name)
      })

      if (OK === response.status) {
        const reInspectionTask = this.$store.getters['tasks/reInspectionTask']

        const payload = {
          jobName: processDefinition.name,
          task: reInspectionTask
        }
        if (reInspectionTask) {
          this.$eventHub.$emit('show-modal-2', 'Reinspection Task', payload, '800px')
        }
      }
    },
    async generateJobNumber() {
      await jobGenerateJobNumber(this, SUPPLY_PRO_CREATE)
    },
    async ifJobNumberExistsThenWarn() {
      await jobIfJobNumberExistsThenWarn(this)
    },
    findCoordinators(text, cb) {
      jobFindCoordinators(this, text, cb, SUPPLY_PRO_CREATE)
    },
    setCoordinator(coordinator) {
      jobSetCoordinator(this, coordinator, SUPPLY_PRO_CREATE)
    },
    verifyCoordinatorAutocompleteSelected() {
      if (!this.$store.get('supplyPro/job/ptracJob@coordinatorId')) {
        this.selectedCoordinator = null
      }
    },
    async findCommunities(text, cb) {
      await findCommunities(this, text, cb, 'supplyPro/job/ptracJob@community')
    },
    verifyCommunityAutocompleteSelected() {
      verifyAutocompleteSelected(this, 'supplyPro/job/ptracJob@community.id', 'community', this.selectedCommunity.name)
    },
    setCommunity(community) {
      jobSetCommunity(this, community, SUPPLY_PRO_CREATE)
    },
    noCommunitySelected() {
      this.selectedCommunity = { id: null, name: null }
    },
    async findCompany(text, type) {
      return findCompany(this, text, type)
    },
    setCompany(company) {
      jobSetCompany(this, company)
    },
    noCompanySelected(type) {
      jobNoCompanySelected(this, type)
    },
    async maybeLoadClient() {
      await jobMaybeLoadClient(this, SUPPLY_PRO_CREATE)
    },
    maybeSetClientContact() {
      if (this.clientContacts.length === 1) {
        this.$store.set(`supplyPro/job/ptracJob@clientContactId`, this.clientContacts[0].value)
        this.checkClientAndContactEmail(this.clientContacts[0].value)
        return
      }
      this.findMatchingPOContact()
    },
    findMatchingPOContact () {
      const matchingFullPOContact = this.clientContacts.find(({ label }) => label.includes(this.poJobData.primaryFirstName + ' ' + this.poJobData.primaryLastName))
      if (matchingFullPOContact) {
        this.$store.set(`supplyPro/job/ptracJob@clientContactId`, matchingFullPOContact.value)
        this.checkClientAndContactEmail(matchingFullPOContact.value)
        return true
      }
      const matchingPOContactLastName = this.clientContacts.find(({ label }) => label.includes(this.poJobData.primaryLastName))
      if (matchingPOContactLastName) {
        this.$store.set(`supplyPro/job/ptracJob@clientContactId`, matchingPOContactLastName.value)
        this.checkClientAndContactEmail(matchingPOContactLastName.value)
        return true
      }
      const matchingPOContactFirstName = this.clientContacts.find(({ label }) => label.includes(this.poJobData.primaryFirstName))
      if (matchingPOContactFirstName) {
        this.$store.set(`supplyPro/job/ptracJob@clientContactId`, matchingPOContactFirstName.value)
        this.checkClientAndContactEmail(matchingPOContactFirstName.value)
        return true
      }
      return false
    },
    async findClients(text, cb) {
      await jobFindClients(this, text, cb, SUPPLY_PRO_CREATE)
    },
    verifyClientAutocompleteSelected() {
      if (!this.newCompany.client && _.get(this, 'selectedClient.name')) {
        verifyAutocompleteSelected(this, 'supplyPro/job/ptracJob@clientId', 'client', this.selectedClient)
      }
    },
    setClient(client) {
      this.$store.set('supplyPro/job/ptracJob@clientContactId', null)
      this.primaryContactInfo = {}
      jobSetClient(this, client, SUPPLY_PRO_CREATE)
      this.maybeFetchTravelCharge()
    },
    checkClientAndContactEmail(contactId) {
      if (contactId !== this.selectedClient.id) {
        this.primaryContactInfo = {}
      }
      const foundContact = objectBy(this.clientContacts, 'value', contactId)
      if (!foundContact) {
        this.primaryContactInfo = {}
        if (contactId) { //Need to test afer adding second condition
          console.error('Unable to find client contact by ID: ' + contactId)
        }
        return
      }
      if (foundContact.contact.workPhone) {
        this.primaryContactInfo.workPhone = foundContact.contact.workPhone
      }
      if (foundContact.contact.mobilePhone) {
        this.primaryContactInfo.mobilePhone = foundContact.contact.mobilePhone
      }
      if (foundContact.contact.emails && foundContact.contact.emails.length > 0) {
        const poEmailMatch = foundContact.contact.emails.find(email => email === this.poJobData.primaryEmailAddress)
        if (poEmailMatch) {
          this.primaryContactInfo.email = poEmailMatch
        } else {
          this.primaryContactInfo.email = foundContact.contact.emails[0]
        }
      }
      if (this.projectSet && (!foundContact.contact.emails || foundContact.contact.emails.length === 0)) {
        const payload = {
          companyId: this.$store.get('supplyPro/job/ptracJob@clientId'),
          contact: foundContact.contact,
          showButton: true
        }
        this.$eventHub.$emit('show-modal-2', 'No Contact Email', payload, '600px')
      }
    },
    async maybeFetchTravelCharge() {
      const job = this.$store.get('supplyPro/job/ptracJob')
      if (job.name && job.clientId && job.departmentId && job.projectId && job.processDefinitionId) {
        const response = await this.$store.dispatch('supplyPro/job/fetchTravelCharge')
        if (OK === response.status) {
          this.travelCharge.value =  response.data.travelCharge
          this.travelCharge.state = response.data.travelChargeState
        }
      }
    },
    async copyClientToBuilder() {
      await jobCopyClientToBuilder(this, SUPPLY_PRO_CREATE)
      this.checkBuilderAndContactEmail(this.$store.get('supplyPro/job/ptracJob@builderContactId'))
    },
    async maybeLoadBuilder() {
      await jobMaybeLoadBuilder(this, SUPPLY_PRO_CREATE)
    },
    async findBuilders(text, cb) {
      await jobFindBuilders(this, text, cb, SUPPLY_PRO_CREATE)
    },
    verifyBuilderAutocompleteSelected() {
      if (!this.newCompany.builder && _.get(this, 'selectedBuilder.name')) {
        verifyAutocompleteSelected(this, 'supplyPro/job/ptracJob@builderId', 'builder', this.selectedBuilder)
      }
    },
    setBuilder(builder) {
      jobSetBuilder(this, builder, SUPPLY_PRO_CREATE)
    },
    checkBuilderAndContactEmail(contactId) {
      const foundContact = objectBy(this.builderContacts, 'value', contactId)
      if (!foundContact) {
        if (contactId) {
          console.error('Unable to find builder contact by ID: ' + contactId)
        }
        return
      }
      if (this.projectSet && (!foundContact.contact.emails || foundContact.contact.emails.length === 0)) {
        const payload = {
          companyId: this.$store.get('supplyPro/job/ptracJob@builderId'),
          contact: foundContact.contact,
          showButton: true
        }
        this.$eventHub.$emit('show-modal-2', 'No Contact Email', payload, '600px')
      }
    },
    verifyBuilderSelected() {
      return jobVerifyBuilderSelected(this, SUPPLY_PRO_CREATE)
    },
    verifyClientOrBuilderSelected() {
      return jobVerifyClientOrBuilderSelected(this, SUPPLY_PRO_CREATE)
    },
    async maybeLoadClientAndBuilder(contact) {
      await Promise.all([
        this.maybeLoadClient(),
        this.maybeLoadBuilder()
      ])
      if (this.isAddClientContact) {
        this.$store.set('supplyPro/job/ptracJob@clientContactId', contact.id)
        this.checkClientAndContactEmail(contact.id)
        this.isAddClientContact = false
      }
      if (this.isAddBuilderContact) {
        this.$store.set('supplyPro/job/ptracJob@builderContactId', contact.id)
        this.isAddBuilderContact = false
      }
    },
    async findPlanNames(text, cb) {
      await jobFindPlanNames(this, text, cb, SUPPLY_PRO_CREATE)
    },
    setPlanName(planName) {
      jobSetPlanName(this, planName, SUPPLY_PRO_CREATE)
      this.fetchPlanNamePDF()
    },
    verifyPlanNameAutocompleteSelected() {
      verifyAutocompleteSelected(this, 'supplyPro/job/ptracJob@planNameId', 'plan name', this.selectedPlanName)
    },
    editPlanName() {
      jobEditPlanName(this, SUPPLY_PRO_CREATE)
    },
    addPlanName() {
      jobAddPlanName(this, SUPPLY_PRO_CREATE)
    },
    async fetchPlanNamePDF() {
      await jobFetchPlanNamePDF(this, SUPPLY_PRO_CREATE)
    },
    noPlanNameSelected() {
      this.selectedPlanName = null
    },
    async addBuilderContact() {
      await jobAddBuilderContact(this, SUPPLY_PRO_CREATE)
    },
    async editBuilderContact() {
      await jobEditBuilderContact(this, SUPPLY_PRO_CREATE)
    },
    async addClientContact() {
      await jobAddClientContact(this, SUPPLY_PRO_CREATE)
    },
    async editClientContact() {
      await jobEditClientContact(this, SUPPLY_PRO_CREATE)
    },
    editDescription() {
      const description = this.$store.get('supplyPro/job/ptracJob@description')
      this.$eventHub.$emit('show-modal-1', 'Edit Description', description, '900px')
    },
    async validateAndSubmit() {
      this.isProcessing = true

      if (await this.$validator.validateAll()) {
        if (!this.$store.get('supplyPro/job/ptracJob@projectId')) { // May be overkill
          console.error('Missing project ID.')
          return
        }
        if (!this.$store.get('supplyPro/job/ptracJob@departmentId')) { // May be overkill
          console.error('Missing department ID.')
          return
        }

        let response = await this.$store.dispatch('supplyPro/job/createJob') // returns response from /attachPurchaseOrderIdToJob endpoint (metadatum object)
        if (OK !== response.status) {
          notifyError(this, 'Failed to Create Job.')
          return
        }
        if (OK === response.status) {
          notifySuccess(this, 'Job Created Successfully.')
          if (await this.loadPtracJobTaskResults(response.data.entityId)) {
            this.$eventHub.$emit('show-modal-2', 'Bulk Edit Tasks', {jobId: response.data.entityId}, '80%')
          }
          this.resetLocalState()
          this.$store.commit('supplyPro/job/resetPtracJob')
          if (this.$store.get('supplyPro/job/createAnotherJob')) {
            this.init()
            this.setDepartmentOptionsFromProject()
            this.maybeSetInspection()
            this.maybeSetSurvey()
          }
        }
      }
      this.isProcessing = false
    },
    async loadPtracJobTaskResults(jobId) {
      // try up to 10 times for PTRAC to return tasks for the newly created job, with 1 second search interval
      for (let i = 0; i < 10; i++) {
        if (await this.loadPtracTasksSetFieldValues(jobId)) {
          return true
        }
        await sleepOneSecond()
      }
      return false
    },
    resetCompanyContactBooleans() {
      this.isAddClientContact = false
      this.isAddBuilderContact = false
    },
    async loadPtracTasksSetFieldValues(jobId) {
      const response = await this.$store.dispatch('tasks/fetchTasksByJobId', jobId)
      for (const task of response.data) {
        if (task.name === 'Invoice Submittal') { // Adding PO Number and Price to Invoice Task. Maybe add more fields later.
          let editedTask = task
          const purchaseOrder = this.$store.get('supplyPro/purchaseOrder/purchaseOrder')
          if (purchaseOrder.header.builderOrderNumber) {
            editedTask.fieldValues.poNumber = purchaseOrder.header.builderOrderNumber
          }
          if (purchaseOrder.items[0].total) {
            editedTask.fieldValues.poPrice = purchaseOrder.items[0].total
          }

          const payload = {
            id: task.id,
            endpoint: 'tasks',
            data: editedTask
          }

          const updateInvoiceResponse = await store.dispatch('put', payload)
          if (!OK === updateInvoiceResponse.status) {
            notifyError('Unable to update Invoice Task Field Values. Please input Purchase Order data manually.')
          }
        }
      }
      return OK === response.status && response.data.length > 0
    },
    maybeLoadCoordinator() {
      jobMaybeLoadCoordinator(this, SUPPLY_PRO_CREATE)
    },
    async maybeSetClientBuilderFromPO() {
      if (this.$store.get('supplyPro/job/poJobData@builderName')) {
        const billableClient = (this.$store.get('supplyPro/job/poJobData@builderName')).toLowerCase().trim().split(' ')
        let billableClientLength = billableClient.length
        for (const value of billableClient) {
          const payload = {
            type: Constants.COMPANY.TYPES.CLIENT,
            name: _.slice(billableClient, 0, billableClientLength).join(' ')
          }
          const response = await this.$store.dispatch('companies/fetchByNameStartsWithAndType', payload)

          if (OK === response.status && response.data.length > 0) {
            this.$store.set('supplyPro/job/ptracJob@clientId', response.data[0].id)
            await this.maybeLoadClient()
            this.maybeSetClientContact()
            await this.copyClientToBuilder(response.data[0])
            return
          }
          billableClientLength --
        }
      }
    },
    async maybeRouteToSearch() {
      if (!this.$store.get('supplyPro/job/createAnotherJob')) {
        // Mark PO as accepted (only after last of multiple possible jobs is created) and remove from POs table
        const response = await this.$store.dispatch('supplyPro/purchaseOrder/markPurchaseOrderAsAccepted')
        if (OK !== response.status) {
            notifyError(this, "Error accepting Job to SPConnect: " + response.data.error)
            // what do we do in this case? An error here could either be an issue creating metadata, or a failed call to SPConnect API
            // the bulkEditTasks modal is already closed, and all the project/job/tasks saved
            // will maybe need some kind of a queue for failed SPConnect calls to retry later?
        }
        await this.$store.dispatch('supplyPro/search/fetchAll')
        await this.$router.push({path: `/admin/supply-pro/`})
      }
      this.$emit('scrollToJob')
      this.$store.set('supplyPro/job/createAnotherJob', false)
    },
    setDepartmentOptionsFromProject() {
      this.isSurvey = false
      this.isInspection = false
      this.canSelectSurvey = false
      this.canSelectInspection = false
      if (this.departmentOptions && this.departmentOptions.length > 0) {
        if (!this.departmentOptions.find(({label}) => label === Constants.DEPARTMENTS.INSPECTIONS)) {
          this.isSurvey = true
          return
        }
        if (!this.departmentOptions.find(({label}) => label === Constants.DEPARTMENTS.SURVEY)) {
          this.isInspection = true
          return
        }
        for (const department of this.departmentOptions) {
          if (department.value === this.user.preferences.global.defaultDepartment && department.label === Constants.DEPARTMENTS.INSPECTIONS) {
            this.isInspection = true
          }
          if (department.value === this.user.preferences.global.defaultDepartment && department.label === Constants.DEPARTMENTS.SURVEY) {
            this.isSurvey = true
          } else {
            this.isInspection = true // Defaults to Inspection if no user preference
          }
        }
        this.canSelectInspection = true
        this.canSelectSurvey = true
      }
    },
    maybeSetInspection() {
      if (this.isInspection) {
        const inspectionsId = this.departmentOptions.find(({label}) => label === Constants.DEPARTMENTS.INSPECTIONS).value
        this.$store.set('supplyPro/job/ptracJob@departmentId', inspectionsId)
        this.$store.dispatch('jobTemplates/fetchByDepartment', inspectionsId)
        this.$store.dispatch('camunda/fetchPtracProcessDefinitionsByDepartment', inspectionsId)
        this.isSurvey = false
      }
    },
    maybeSetSurvey() {
      if (this.isSurvey) {
        const surveyId = this.departmentOptions.find(({label}) => label === Constants.DEPARTMENTS.SURVEY).value
        this.$store.set('supplyPro/job/ptracJob@departmentId', surveyId)
        this.$store.dispatch('jobTemplates/fetchByDepartment', surveyId)
        this.$store.dispatch('camunda/fetchPtracProcessDefinitionsByDepartment', surveyId)
        this.isInspection = false
      }
    },
    resetLocalState() {
      this.isInspection = false
      this.isSurvey = false
      this.canSelectSurvey = false
      this.canSelectInspection = false
      this.jobTemplate = null
      this.selectedPlanName = null
      this.planNamePDF = null
      this.selectedCommunity = { id: null, name: null }
      this.selectedClient = { id: null, name: null }
      this.selectedBuilder = { id: null, name: null }
      this.isClientResult = false
      this.isBuilderResult = false
      this.onHoldWarning = false
      this.primaryContactInfo = {}
      this.$validator.reset()
      this.$validator.pause()
      this.selectedPlanName = null
      this.selectedCoordinator = null
      this.clientContacts = []
      this.builderContacts = []
      this.resetCompanyContactBooleans()
      setTimeout(() => this.$validator.resume(), Constants.TIME.MILLIS.QUARTER_SECOND)
    },
    init() {
      this.$store.set('supplyPro/job/ptracJob@coordinatorId', this.$store.get('security/userId'))
      this.$store.set('supplyPro/job/ptracJob@projectId', this.$store.get('supplyPro/project/ptracProject@id'))
      this.maybeLoadCoordinator()
      this.$store.commit('supplyPro/job/setFieldsFromPO')
      this.maybeSetClientBuilderFromPO()
    },
  },
  async created() {
    await this.$store.dispatch('supplyPro/job/setPoJobData')
    await this.$store.dispatch('supplyPro/job/populateDepartmentFromProject')
  },
  mounted() {
    this.$store.cache.dispatch('statuses/fetchByEntityType', 'Job')
    this.$store.cache.dispatch('priorities/fetchByEntityType', 'Job')

    this.$eventHub.$on('companySaved', this.setCompany)
    this.$eventHub.$on('noCompanySelected', this.noCompanySelected)
    this.$eventHub.$on('communitySaved', this.setCommunity)
    this.$eventHub.$on('noCommunitySelected', this.noCommunitySelected)
    this.$eventHub.$on('planNameSaved', this.setPlanName)
    this.$eventHub.$on('noPlanNameSelected', this.noPlanNameSelected)
    this.$eventHub.$on('companyContactUpdated', this.maybeLoadClientAndBuilder)
    this.$eventHub.$on('noCompanyContactSelected', this.resetCompanyContactBooleans)
    this.$eventHub.$on('bulkEditTasksClosed', this.maybeRouteToSearch)
    this.init()
  },
  destroyed() {
    this.$eventHub.$off('companySaved')
    this.$eventHub.$off('noCompanySelected')
    this.$eventHub.$off('communitySaved')
    this.$eventHub.$off('noCommunitySelected')
    this.$eventHub.$off('planNameSaved')
    this.$eventHub.$off('noPlanNameSelected')
    this.$eventHub.$off('companyContactUpdated')
    this.$eventHub.$off('noCompanyContactSelected')
    this.$eventHub.$off('bulkEditTasksClosed')
    this.resetLocalState()
  },
  watch: {
    departmentOptions: {       // May not be necessary depending on how Project Confirmation is implemented
      handler: function () {
        this.setDepartmentOptionsFromProject()
      }
    },
    selectedCoordinator: {
      handler: function (selectedCoordinator) {
        if (!selectedCoordinator) {
          this.$store.set('supplyPro/job/ptracJob@coordinatorId', null)
        }
      }
    },
    isSurvey: {
      handler: function (isSurvey) {
        this.maybeSetSurvey()
        if (!isSurvey && !this.isInspection) {
          this.$store.set('supplyPro/job/ptracJob@departmentId', null)
        }
      }
    },
    isInspection: {
      handler: function (isInspection) {
        this.maybeSetInspection()
        if (!isInspection && !this.isSurvey) {
          this.$store.set('supplyPro/job/ptracJob@departmentId', null)
        }
      }
    },
    jobTemplate: {
      handler: function(jobTemplate) {
        if (!jobTemplate) {
          this.$store.set('supplyPro/job/ptracJob@jobTemplateId', null)
          this.$store.set('supplyPro/job/ptracJob@name', null)
        }
      }
    },
    projectSet: {
      handler: function(projectSet) {
        if (!projectSet) {
          notifyWarning(this, 'Resetting Job')
          this.resetLocalState()    // Maybe refactor Job reset(Here and when creating a second job)
          this.$store.commit('supplyPro/job/resetPtracJob')
          this.init()
          this.setDepartmentOptionsFromProject()
          this.maybeSetInspection()
          this.maybeSetSurvey()
          this.$store.set('supplyPro/job/ptracJob@projectId', this.$store.get('supplyPro/project/ptracProject@id'))
        }
      }
    },
    selectedPlanName: {
      handler: function (selectedPlanName) {
        if (!selectedPlanName) {
          this.$store.commit('planNames/results', [])
          this.$store.set('supplyPro/job/ptracJob@planNameId', null)
          this.planNamePDF = null
        }
      }
    },
    'selectedBuilder.name': {
      handler: function (selectedBuilderName) {
        if (!selectedBuilderName) {
          this.isBuilderResult = false
          this.$store.commit('companies/autocompleteResultsBuilder', [])
          this.$store.set('supplyPro/job/ptracJob@builderId', null)
          this.$store.set('supplyPro/job/ptracJob@builderContactId', null)
          this.selectedBuilder = { id: null, name: null }
          this.builderContacts = []
        }
      }
    },
    'selectedClient.name': {
      handler: function (selectedClientName) {
        if (!selectedClientName) {
          this.isClientResult = false
          this.$store.commit('companies/autocompleteResultsClient', [])
          this.$store.set('supplyPro/job/ptracJob@clientId', null)
          this.$store.set('supplyPro/job/ptracJob@clientContactId', null)
          this.$validator.errors.remove('clientId')
          this.selectedClient = { id: null, name: null }
          this.travelCharge = { state: null, value: null }
          this.clientContacts = []
          this.primaryContactInfo = {}
        }
      }
    },
    'selectedCommunity.name': {
      handler: function (selectedCommunityName) {
        if (!selectedCommunityName) {
          this.$store.set('supplyPro/job/ptracJob@community', {})
          this.selectedCommunity = { id: null, name: null }
        }
      }
    }
  }
}
</script>

<style scoped>
  .m-left-10 {
    margin-left: 10px;
  }
  .m-left-5 {
    margin-left: 5px;
  }
  .labels {
    font-size: 13px;
    color: #34B5B8;
  }
  .line {
    margin-top: 7px;
    padding-bottom: 4px;
    border-top: 1px solid rgba(0,0,0,.1);
  }
  .sp-align-fields {
    display: flex;
    align-items: center;
  }
  .push-button {
    display: inline-block;
    float: right;
  }
  .contact-info {
    margin-left: 30px;
  }
</style>
